import { LIST_SORTING_EXCEPTION } from '@/configuration/parametrage/parameterConf';
import transform from '@/services/parametrage/filters/parametrageServerTableDataTransformer';
import HTTP from '../HTTP';

export async function getAll(type) {
  let tri = 'libelle ASC';
  const exceptionTri = LIST_SORTING_EXCEPTION.find((ex) => {
    return ex.type === type;
  });
  if (exceptionTri) {
    tri = exceptionTri.tri;
  }
  const queryItems = {
    params: {
      MaxResultCount: 999,
      Sorting: tri,
    },
  };
  const response = await HTTP.get(type + '/GetAllAsync', queryItems);
  return response;
}

export async function pGetAll(type, serverTableData) {
  const inputTable = transform(type, serverTableData);
  const response = await HTTP.post(type + '/PGetAllAsync', inputTable);
  return response;
}

export async function update(type, data) {
  const response = await HTTP.put(type + '/UpdateAsync', data);
  return response;
}

export async function create(type, data) {
  const response = await HTTP.post(type + '/CreateAsync', data);
  return response;
}

export async function archiver(type, data) {
  const response = await HTTP.post(type + '/ArchiverAsync', data);
  return response;
}

export async function remove(type, id) {
  const response = await HTTP.delete(type + '/DeleteAsync', { params: { id } });
  return response;
}
